import type { ChangeEvent } from "react";
import { TextField, InputAdornment } from "@mui/material";
import { SearchIcon } from "@heroicons/react/outline";
import type { TextFieldProps } from "@mui/material/TextField";

export interface TableSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  width: number | string;
  searchBarProps?: Partial<TextFieldProps>;
}

const TableSearchField = ({
  value,
  onChange,
  placeholder,
  width,
  searchBarProps,
}: TableSearchFieldProps) => (
  <TextField
    {...(searchBarProps || {})}
    value={value}
    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    placeholder={placeholder}
    variant="outlined"
    size="small"
    sx={{
      width,
      "& .MuiOutlinedInput-root": { borderRadius: "8px" },
      ...(searchBarProps?.sx || {}),
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <SearchIcon stroke="gray" strokeWidth={1.5} height={18} width={18} />
        </InputAdornment>
      ),
      ...(searchBarProps?.InputProps || {}),
    }}
  />
);

export default TableSearchField;
